import type { UIMessage } from "ai";

type Args = {
  text: string;
  status: string;
  actionLoading: boolean;
  activePending: { approvalReady: boolean } | null;
  appendUserChatMessage: (userText: string, metadata?: unknown) => UIMessage[];
  revisePendingProposal: ((userText: string, messagesWithUser: UIMessage[]) => void) | null;
  sendMessage: (args: { text: string }) => Promise<void>;
};

/**
 * Sends a user chat message. When a write proposal is pending, declines the suspended
 * tool with the user's text as the revision reason (no Reject UI message).
 */
export async function submitAssistantChatMessage({
  text,
  status,
  actionLoading,
  activePending,
  appendUserChatMessage,
  revisePendingProposal,
  sendMessage,
}: Args): Promise<void> {
  const trimmed = text.trim();
  if (!trimmed || status === "streaming" || status === "submitted" || actionLoading) {
    return;
  }

  if (activePending?.approvalReady && revisePendingProposal) {
    const withUser = appendUserChatMessage(trimmed);
    revisePendingProposal(trimmed, withUser);
    return;
  }

  await sendMessage({ text: trimmed });
}
